import {Component, inject, Input} from '@angular/core';
import {ColDef, FirstDataRenderedEvent, GridSizeChangedEvent} from "ag-grid-community";
import {IBroadcastNotification} from "../../interfaces/notifications/IBroadcastNotification";
import {AgGridAngular} from "ag-grid-angular";
import {BroadcastNotificationTables} from "../../table-definitions/broadcast-notification-tables";

@Component({
  selector: 'app-broadcast-notifications-table',
  standalone: true,
  templateUrl: './broadcast-notifications-table.component.html',
  imports: [
    AgGridAngular
  ],
  styleUrls: ['./broadcast-notifications-table.component.css']
})
export class BroadcastNotificationsTableComponent {

  private broadcastNotificationTables: BroadcastNotificationTables = inject(BroadcastNotificationTables);

  @Input()
  public notifications: IBroadcastNotification[] = [];

  public broadcastNotificationColDefs: ColDef[] = this.broadcastNotificationTables.broadcastNotificationColDefs;

  constructor() {
  }

  gridSizeChanged(params: GridSizeChangedEvent) {
    params.api.sizeColumnsToFit();
  }

  onFirstDataRendered(params: FirstDataRenderedEvent) {
    params.api.sizeColumnsToFit();
  }
}
